import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';

import { Footer } from '@/layouts/components/footer';
import { Header } from '@/layouts/components/header';

// Public chrome for the landing page (and other future marketing surfaces).
// Header + Outlet + Footer in a min-h-screen flex column so the footer pins to the
// bottom even when the body is short.

export function LandingLayout() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'background.default',
      }}
    >
      <Header />
      <Outlet />
      <Footer />
    </Box>
  );
}
